import { render, staticRenderFns } from "./DocViewer.vue?vue&type=template&id=5c8dc47c&scoped=true&"
import script from "./DocViewer.vue?vue&type=script&lang=js&"
export * from "./DocViewer.vue?vue&type=script&lang=js&"
import style0 from "./DocViewer.vue?vue&type=style&index=0&id=5c8dc47c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8dc47c",
  null
  
)

export default component.exports